import TemplatesList from "./TemplatesList";

export default function ChatTemplates() {
  return <TemplatesList />;
}
